import { Link } from "react-router-dom";
import { LegalLayout, LegalSection } from "@/components/LegalLayout";
import { BRAND } from "@/constants/compliance";

export default function TermsPage() {
  return (
    <LegalLayout
      testId="terms-page"
      eyebrow="Legal"
      title="Terms of Service"
      updated="July 1, 2026"
    >
      <LegalSection num="01" title="Program description" testId="terms-section-program">
        <p>
          {BRAND.name} ("we", "us", "our") operates an SMS messaging program
          that delivers automated task reminders and schedule updates to
          subscribed users at {BRAND.domain}. By opting in, you agree to these
          Terms of Service.
        </p>
      </LegalSection>

      <LegalSection num="02" title="How you opt in" testId="terms-section-optin">
        <p>You may subscribe to our messaging program in either of two ways:</p>
        <p>
          <span className="font-semibold text-[#1E2022]">Keyword opt-in:</span>{" "}
          text the keyword {BRAND.keyword} to {BRAND.number}. You will receive
          an automated welcome message confirming your subscription.
        </p>
        <p>
          <span className="font-semibold text-[#1E2022]">Website opt-in:</span>{" "}
          complete the registration form on our website and check the consent
          box agreeing to receive recurring automated text messages at the
          mobile number you provide.
        </p>
        <p>
          Consent to receive messages is not a condition of any purchase.
        </p>
      </LegalSection>

      <LegalSection num="03" title="Message frequency" testId="terms-section-frequency">
        <p>
          Message frequency varies based on the number of tasks and reminders
          you schedule. You will only receive messages related to your own
          reminders, schedule updates, and service support.
        </p>
      </LegalSection>

      <LegalSection num="04" title="Message and data rates" testId="terms-section-rates">
        <p>
          Message and data rates may apply to messages sent to you and by you.
          If you have questions about your text or data plan, contact your
          wireless provider. You are responsible for any charges from your
          carrier.
        </p>
      </LegalSection>

      <LegalSection num="05" title="How to opt out" testId="terms-section-optout">
        <p>
          You can cancel the SMS service at any time. Simply text{" "}
          <span className="font-semibold text-[#1E2022]">STOP</span> to{" "}
          {BRAND.number}. Upon sending STOP, we will send a confirmation of
          your unsubscribe status and you will no longer receive messages from
          us. If you wish to rejoin, text {BRAND.keyword} again or sign up on
          our website.
        </p>
      </LegalSection>

      <LegalSection num="06" title="Getting help" testId="terms-section-help">
        <p>
          Text <span className="font-semibold text-[#1E2022]">HELP</span> to{" "}
          {BRAND.number} at any time for assistance, or email us at{" "}
          {BRAND.email}. We respond to support requests as quickly as
          possible.
        </p>
      </LegalSection>

      <LegalSection num="07" title="Carrier liability" testId="terms-section-carriers">
        <p>
          Carriers are not liable for delayed or undelivered messages. Service
          is available on major US carriers; availability may vary and is
          subject to your carrier's terms.
        </p>
      </LegalSection>

      <LegalSection num="08" title="Privacy" testId="terms-section-privacy">
        <p>
          Your privacy matters to us. Please review our{" "}
          <Link to="/privacy" data-testid="terms-privacy-link" className="text-[#D96B43] underline underline-offset-2 hover:text-[#C25832]">
            Privacy Policy
          </Link>{" "}
          for details on how we collect, use, and protect your information,
          including your mobile number and opt-in consent data.
        </p>
      </LegalSection>

      <LegalSection num="09" title="Changes & contact" testId="terms-section-contact">
        <p>
          We may update these terms from time to time; the latest version is
          always posted at {BRAND.domain}/terms. Questions? Contact us at{" "}
          {BRAND.email}.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
